export default {"src":"/_next/static/media/IconPrivacy.5f76e4cd.svg","height":25,"width":21,"blurWidth":0,"blurHeight":0};